import { motion } from "framer-motion";
import { Reveal, SectionHead } from "./Reveal";
import { ICONS } from "@/lib/icons";

export default function Promise({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="promise-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHead
          index="03"
          label="Our Promise"
          title="Three commitments we never negotiate."
          description="Every partner, every transaction, every day — these are the standards our platform is held to."
          testId="promise-head"
        />
        <div className="grid gap-6 md:grid-cols-3">
          {items.map((p, i) => {
            const Icon = ICONS[p.icon] || ICONS.BadgeCheck;
            return (
              <Reveal key={i} delay={i * 0.1} className="h-full">
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 300, damping: 22 }}
                  className="flex h-full flex-col rounded-2xl border border-[#E2DDD5] bg-[#FAF9F5] p-8 shadow-sm transition-all duration-300 hover:border-[#B8860B]/40 hover:bg-white hover:shadow-md"
                  data-testid={`promise-card-${i}`}
                >
                  <span className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-[#B8860B]/10 text-[#B8860B]">
                    <Icon size={22} strokeWidth={1.8} />
                  </span>
                  <h3 className="font-syne text-xl font-semibold text-[#0F1B2B]">{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#5A6578]">{p.description}</p>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
